import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';
import OrderDisplay from './order-display';

class Message extends Component {
  render() {
    const {
      email,
      contactOptOut,
      contactPreferences,
      order,
      orderTotal,
      orderTotalPrefix,
      receiptUrl,
      preferenceUrl,
      printReceipt
    } = this.props;

    return (
      <div>
        { email && <p className='font-base'>{ email }</p> }
        { preferenceUrl && contactPreferences && contactOptOut && (
          <p>
            <span>{ contactOptOut }</span>
            <a href={ preferenceUrl } target='_blank' rel='noopener noreferrer'>
              <span className='link-style contact-preferences'>
                { contactPreferences }
              </span>
            </a>
          </p>
        )}
        { order && <OrderDisplay { ...order } /> }
        { orderTotal && orderTotalPrefix && (
          <p>
            <span className='font-base'>
              { orderTotalPrefix } <strong>{ orderTotal }</strong>
            </span>
          </p>
        )}
        { receiptUrl && printReceipt && (
          <span>
            <span className='uxicon uxicon-page' />
            <a href={ receiptUrl } target='_blank' rel='noopener noreferrer'>
              <span className='link-style receipt'>{ printReceipt }</span>
            </a>
          </span>
        )}
      </div>
    );
  }
}

Message.propTypes = {
  email: PropTypes.string,
  contactOptOut: PropTypes.string,
  contactPreferences: PropTypes.string,
  order: PropTypes.object,
  orderTotal: PropTypes.string,
  orderTotalPrefix: PropTypes.string,
  preferenceUrl: PropTypes.string,
  printReceipt: PropTypes.string,
  receiptUrl: PropTypes.string
};

export default Message;
